import React from 'react';
import Switch from '@jbhi-fi/lanyard-ui/components/Switch';
import { styles } from './ToggleButtonRefinement/ToggleButtonRefinement.css';
import { useGoogleSearchContext } from '../../../components/search/GoogleInstantSearch';

type GoogleToggleRefinementProps = {
  facet: string;
  isSearchPage?: boolean;
};

const TOGGLE_CONFIG: Record<string, { label: string; stateKey: 'isExcludeMarketplace' }> = {
  isMarketplace: { label: 'Exclude Marketplace products', stateKey: 'isExcludeMarketplace' },
};

const GoogleToggleRefinement = ({ facet, isSearchPage = false }: GoogleToggleRefinementProps) => {
  const { state, setExcludeMarketplace } = useGoogleSearchContext();
  const config = TOGGLE_CONFIG[facet];

  if (!config) return null;

  const isChecked = state[config.stateKey];

  const handleToggle = (checked: boolean) => {
    setExcludeMarketplace(checked);
  };

  return (
    <div className={styles.container({ isSearchPage })}>
      <Switch
        label={config.label}
        onToggle={handleToggle}
        classes={styles.toggleButton({ isSearchPage })}
        defaultChecked={isChecked}
        isMobileFullSize
      />
    </div>
  );
};

export default GoogleToggleRefinement;
